// src/components/store/sections/product-cards/Variant26CathedralWaveFuchsiaGlowCard.tsx
"use client";

import Image from "next/image";
import Link from "next/link";
import { Star, ShoppingBag, Check } from "lucide-react";
import { UniversalProductCardProps, useCardActions } from "./useCardActions";

export default function Variant26CathedralWaveFuchsiaGlowCard({
  product,
  subdomain = "nextlook",
}: UniversalProductCardProps) {
  const {
    productImg,
    productName,
    productUrl,
    categoryName,
    rating,
    currentPrice,
    added,
    handleAddToCart,
  } = useCardActions(product, subdomain);

  return (
    <div className="w-full h-full rounded-t-[90px] rounded-b-[28px] bg-gradient-to-b from-fuchsia-500 to-pink-600 p-1.5 shadow-lg hover:shadow-2xl transition-all duration-300 flex flex-col justify-between group select-none overflow-hidden">
      <div className="pt-3 px-4 flex flex-col items-center">
        <span className="px-3 py-0.5 rounded-full bg-white/90 text-slate-900 font-mono font-black text-xs shadow-xs">
          ৳{currentPrice.toLocaleString()}
        </span>
        <Link href={productUrl} className="relative w-36 h-36 my-2 block">
          <Image src={productImg} alt={productName} fill unoptimized className="object-contain group-hover:scale-110 transition-transform duration-500 drop-shadow-xl" />
        </Link>
      </div>

      <div className="bg-white rounded-t-[48px] rounded-b-[22px] pt-5 pb-4 px-4 text-center space-y-2 shadow-inner">
        <span className="text-[9px] font-black uppercase tracking-widest text-fuchsia-700 block truncate">{categoryName}</span>
        <Link href={productUrl} className="block">
          <h3 className="text-sm font-black text-slate-900 truncate hover:underline">{productName}</h3>
        </Link>
        <div className="flex items-center justify-center gap-1 text-amber-400">
          {[1, 2, 3, 4, 5].map((s) => (
            <Star key={s} className="w-3 h-3 fill-amber-400" />
          ))}
          <span className="text-[10px] text-slate-400 font-bold ml-1">({rating.toFixed(1)})</span>
        </div>
        <button
          type="button"
          onClick={(e) => handleAddToCart(e)}
          className="w-full py-2 rounded-full bg-fuchsia-600 hover:bg-fuchsia-700 text-white font-black text-[10px] uppercase tracking-wider shadow-sm active:scale-95 transition-all cursor-pointer flex items-center justify-center gap-1"
        >
          {added ? <Check className="w-3.5 h-3.5" /> : <ShoppingBag className="w-3.5 h-3.5" />}
          <span>{added ? "Added" : "Add to Cart"}</span>
        </button>
      </div>
    </div>
  );
}
